// src/pages/BibleStudyMaterial.js
import React, { useState, useEffect, useContext } from 'react';
import { GlobalContext } from '../contexts/GlobalContext';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import './BibleStudyMaterial.css';

function BibleStudyMaterial() {
    const [bibleStudyMaterialData, setBibleStudyMaterialData] = useState(null);
    const [noBibleStudyMaterialData, setNoBibleStudyMaterialData] = useState(null);
    const { id } = useParams();
    const { isLoggedIn, userLevel } = useContext(GlobalContext);
    
    useEffect(() => {
        axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/api/getBibleStudyMaterials/${id}`, {
            withCredentials: true, // Include credentials (cookies)
        })
        .then((response) => {
            setBibleStudyMaterialData(response.data);
        })
        .catch((error) => {
            if (error.response) {
            setNoBibleStudyMaterialData(error.response.data);
            } else {
            console.error('Error fetching data:', error);
            }
        });
    }, [id]);

    if (!bibleStudyMaterialData) {
        if (noBibleStudyMaterialData)
        return (
            <div className="page-content">
            <h2>查經資料</h2>
            <p className="error">
                抱歉，查經資料編號：{id}並不存在或您無權訪問。
            </p>
            <Link to="/bible-study-materials">
                <button className="button button-m">返回【查經資料】</button>
            </Link>
            </div>
        );
        return <div>加載中 Loading...</div>;
    }

    return (
        <div className="page-content">
            <div className="header-container">
                <h2>查經資料</h2>
                {isLoggedIn ? (
                    <Link to="/logout">
                        <button className="button button-m">
                            組長登出
                        </button>
                    </Link>
                ) : (
                    <Link to="/login">
                        <button className="button button-m">
                            組長登入
                        </button>
                    </Link>
                )}
            </div>
            <h1>{bibleStudyMaterialData.title}</h1>
            <h3>
                經文：{bibleStudyMaterialData.bible}
                <br />
                日期：{new Date(bibleStudyMaterialData.date).toLocaleDateString()}
            </h3>
            <div dangerouslySetInnerHTML={{ __html: bibleStudyMaterialData.content }} />
        </div>
    );
}

export default BibleStudyMaterial;


// // src/pages/BibleStudyMaterial.js
// import React, { useState, useEffect, useContext } from 'react';
// import { useParams, Link } from 'react-router-dom';
// import axios from 'axios';

// function BibleStudyMaterial() {
//     const [bibleStudyMaterialData, setBibleStudyMaterialData] = useState(null);
//     const [noBibleStudyMaterialData, setNoBibleStudyMaterialData] = useState(null);
//     const { id } = useParams();

//     useEffect(() => {        
//         axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getBibleStudyMaterials/${id}`)
//         .then((response) => {
//             setBibleStudyMaterialData(response.data);
//             console.log(response.data)
//         })
//         .catch((error) => {
//             setNoBibleStudyMaterialData(error.response.data);
//             console.error("There was an error fetching the data!", error);
//         });
//     }, []);

//     if (!bibleStudyMaterialData) {
//         if (noBibleStudyMaterialData)
//             return (<div className="page-content">
//                 <h2>查經資料</h2>
//                 <p className='error'>
//                     抱歉，查經資料編號：{id}並不存在。
//                 </p>
//                 <Link to="/bible-study-materials">
//                     <button className='button button-m'>
//                         返回【查經資料】
//                     </button>
//                 </Link>
//             </div>)
//         return <div>加載中 Loading...</div>;
//     }

//   return (
//     <div className="page-content">
//         <h2>查經資料</h2>
//         <h1>
//             {bibleStudyMaterialData.title}
//         </h1>
//         <h3>經文：{bibleStudyMaterialData.bible}<br />
//         日期：{new Date(bibleStudyMaterialData.date).toLocaleDateString()}</h3>
//         <div dangerouslySetInnerHTML={{ __html: bibleStudyMaterialData.content }} />
//     </div>
//   );
// }

// export default BibleStudyMaterial;